<div cla>
  <div class="flex justify-between items-center mb-4">
    <div class="text-lg uppercase tracking-widest text-white" data-testid="book-meeting-title">Book a meeting</div>
    <div class="text-right cursor-pointer" data-testid="book-meeting-close" (click)="closeWindow()">
      <div class="text-white">X</div>
    </div>
  </div>
  <div class="space-y-4">
    <div>
      <p class="mb-2 text-white" data-testid="book-meeting-description">
        If you are interested in a meeting with
        {{ data.data.companySettings().name }} please complete the data.
      </p>

      <div class="mb-4">
        <input
          class="w-full px-3 py-2 border border-gray-300 rounded-sm"
          data-testid="book-meeting-firstname"
          placeholder="First Name*"
          required
          type="text"
          [(ngModel)]="firstname" />
        @if (requiredFieldMissingInput) {
          <label class="text-red-500" data-testid="book-meeting-firstname-error">This field must be filled.</label>
        }
      </div>
      <div class="mb-4">
        <input
          class="w-full px-3 py-2 border border-gray-300 rounded-sm"
          data-testid="book-meeting-lastname"
          placeholder="Last Name*"
          required
          type="text"
          [(ngModel)]="lastname" />
        @if (requiredFieldMissingInput) {
          <label class="text-red-500" data-testid="book-meeting-lastname-error">This field must be filled.</label>
        }
      </div>
      <div class="mb-4">
        <input
          class="w-full px-3 py-2 border border-gray-300 rounded-sm"
          data-testid="book-meeting-email"
          placeholder="Email*"
          required
          type="text"
          [(ngModel)]="email" />
        @if (requiredFieldMissingInput) {
          <label class="text-red-500" data-testid="book-meeting-email-error">This field must be filled.</label>
        }
      </div>
      <div class="mb-4">
        <input
          class="w-full px-3 py-2 border border-gray-300 rounded-sm"
          data-testid="book-meeting-company"
          placeholder="Your Company*"
          required
          type="text"
          [(ngModel)]="requesterscompany" />
        @if (requiredFieldMissingInput) {
          <label class="text-red-500" data-testid="book-meeting-company-error">This field must be filled.</label>
        }
      </div>
      <div class="mb-4">
        <input
          class="w-full px-3 py-2 border border-gray-300 rounded-sm"
          data-testid="book-meeting-phone"
          placeholder="Phone"
          type="text"
          [(ngModel)]="phonenumber" />
      </div>
      <div class="text-center">
        <button
          class="px-4 py-2 bg-brand-500 text-white rounded-sm transition-opacity"
          data-testid="book-meeting-submit"
          [class.cursor-not-allowed]="requestPending"
          [class.opacity-50]="requestPending"
          [disabled]="requestPending"
          (click)="sendNotification()">
          @if (requestPending) {
            <span>Sending request...</span>
          } @else {
            <span>Send a request</span>
          }
        </button>
      </div>
      @if (requestSent) {
        <div class="text-center mt-2" data-testid="book-meeting-success">
          <label> Your request has been sent. We will get in touch with you as soon as possible. </label>
        </div>
      }
    </div>
  </div>
</div>
